var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPinHome = function SvgMapPinHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4827_6930)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 22.5,
    rx: 7,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.24
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C12 22 20 16.788 20 10.2051C20 5.67356 16.4183 2 12 2C7.58172 2 4 5.67356 4 10.2051C4 16.788 12 22 12 22Z",
    fill: "#D61132",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.19309V13.5C16 13.7761 15.7761 14 15.5 14H13.8333C13.5572 14 13.3333 13.7761 13.3333 13.5V11.1162C13.3333 10.6252 12.9354 10.2273 12.4444 10.2273H11.5556C11.0646 10.2273 10.6667 10.6252 10.6667 11.1162V13.5C10.6667 13.7761 10.4428 14 10.1667 14H8.5C8.22386 14 8 13.7761 8 13.5V9.19231C8 8.91084 8.13332 8.646 8.3594 8.47833L11.4654 6.17491C11.7796 5.94197 12.209 5.94167 12.5234 6.17417L15.6396 8.47837C15.8663 8.64598 16 8.91118 16 9.19309Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4827_6930",
    x: 1,
    y: 17,
    width: 22,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4827_6930"
  })))));
};
export default SvgMapPinHome;